import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=8668e3fe&scoped=true"
import script from "./StaffView.vue?vue&type=script&lang=js"
export * from "./StaffView.vue?vue&type=script&lang=js"
import style0 from "./StaffView.vue?vue&type=style&index=0&id=8668e3fe&prod&scoped=true&lang=css"
import style1 from "./StaffView.vue?vue&type=style&index=1&id=8668e3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8668e3fe",
  null
  
)

export default component.exports